<template>
  <div class="icon-iot">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform="translate(9 9)"
        stroke="none"
        stroke-width="2"
        fill="none"
        fill-rule="evenodd"
        stroke-linecap="round"
        class="icon-iot__path"
      >
        <!-- eslint-disable max-len -->
        <path
          class="icon-iot__path icon-iot__path__path-1"
          d="M42.3105,-0.0002 C18.9435,-0.0002 -0.0005,18.9428 -0.0005,42.3098 C-0.0005,65.6768 18.9435,84.6198 42.3105,84.6198 C65.6775,84.6198 84.6205,65.6768 84.6205,42.3098 C84.6205,18.9428 65.6775,-0.0002 42.3105,-0.0002"
          stroke="#FFFFFF"
          stroke-width="2"
        />
        <g
          transform="translate(17.000000, 22.000000)"
          stroke="#FFFFFF"
          stroke-width="2"
        >
          <path
            class="icon-iot__path icon-iot__path__path-2"
            d="M3.7695,35.0559 C2.1135,35.0559 0.7695,33.7129 0.7695,32.0559 L0.7695,3.7699 C0.7695,2.1129 2.1135,0.7699 3.7695,0.7699 L43.4845,0.7699 C45.1405,0.7699 46.4845,2.1129 46.4845,3.7699 L46.4845,9.47587885"
          />
          <path
            class="icon-iot__path icon-iot__path__path-2"
            d="M27.3988117,35.0559 C26.2948117,35.0559 18.4183745,35.0559 3.7695,35.0559 C2.1135,35.0559 0.7695,33.7129 0.7695,32.0559 L0.7695,26.4839 L27.3988117,26.4839"
          />
          <g transform="translate(30.000000, 12.000000)">
            <path
              class="icon-iot__path icon-iot__path__path-2"
              d="M17.68,28.57125 L3.75,28.57125 C1.68,28.57125 0,26.8925 0,24.82125 L0,3.75 C0,1.67875 1.68,0 3.75,0 L17.68,0 C19.75,0 21.43,1.67875 21.43,3.75 L21.43,24.82125 C21.43,26.8925 19.75,28.57125 17.68,28.57125 Z"
            />
            <g transform="translate(4.000000, 10.000000)">
              <path
                class="icon-iot__path icon-iot__path__path-2"
                d="M8.0557,7.2585 C8.0557,8.0475 7.4157,8.6875 6.6267,8.6875 C5.8377,8.6875 5.1987,8.0475 5.1987,7.2585 C5.1987,6.4695 5.8377,5.8305 6.6267,5.8305 C7.4157,5.8305 8.0557,6.4695 8.0557,7.2585 Z"
              />
              <path
                class="icon-iot__path icon-iot__path__path-2"
                d="M12.8272,3.9665 C11.6472,1.7485 9.3142,0.2375 6.6272,0.2375 C3.9392,0.2375 1.6072,1.7485 0.4272,3.9665"
              />
              <path
                class="icon-iot__path icon-iot__path__path-2"
                d="M10.6788,6.1154 C10.1798,4.3444 8.5568,3.0454 6.6268,3.0454 C4.6978,3.0454 3.0748,4.3444 2.5748,6.1154"
              />
            </g>
            <path
              class="icon-iot__path icon-iot__path__path-2"
              d="M17.8575,28.57125 L3.57125,28.57125 C1.59875,28.57125 0,26.9725 0,25 L21.42875,25 C21.42875,26.9725 19.83,28.57125 17.8575,28.57125 Z"
            />
          </g>
        </g>
        <!-- eslint-enable max-len -->
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  name: 'IconIot'
};
</script>

<style lang="scss" src="@/assets/icons/icon-iot-view.scss"></style>



// WEBPACK FOOTER //
// icon-iot-view.vue